export default __webpack_public_path__ + "static/media/waves.f227cfaf.svg";